// extracted by mini-css-extract-plugin
export default {"EledoLoader":"EledoLoader_EledoLoader__MxBnQ","scaling":"EledoLoader_scaling__2yp+C"};